import React from 'react';
import { Box, Flex, Text, VStack, HStack, Link, SimpleGrid, IconButton, Divider } from '@chakra-ui/react';
import { InstagramIcon, FacebookIcon } from 'lucide-react';
// TikTok icon (not in lucide-react, so we use a simple SVG)
function TikTokIcon({
  size = 18
}: {
  size?: number;
}) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" data-id="element-71">
      <path d="M19.59 6.69a4.83 4.83 0 01-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 01-2.88 2.5 2.89 2.89 0 01-2.89-2.89 2.89 2.89 0 012.89-2.89c.28 0 .54.04.79.1V9.01a6.33 6.33 0 00-.79-.05 6.34 6.34 0 00-6.34 6.34 6.34 6.34 0 006.34 6.34 6.34 6.34 0 006.33-6.34V8.69a8.18 8.18 0 004.78 1.52V6.76a4.85 4.85 0 01-1.01-.07z" data-id="element-72" />
    </svg>;
}
export function Footer() {
  return <Box as="footer" bg="#3A3A3A" color="white" pt={{
    base: 12,
    md: 16
  }} pb={0} data-id="element-73">
      <Box maxW="1280px" mx="auto" px={{
      base: 6,
      md: 12
    }} data-id="element-74">
        <SimpleGrid columns={{
        base: 1,
        md: 2,
        lg: 4
      }} spacing={{
        base: 10,
        md: 8
      }} pb={{
        base: 12,
        md: 16
      }} data-id="element-75">
          {/* Column 1: Logo + tagline + social */}
          <VStack align={{
          base: 'center',
          lg: 'flex-start'
        }} spacing={4} data-id="element-76">
            <Text className="font-script" fontSize="36px" color="#F4B8C1" lineHeight={1.1} data-id="element-77">
              Love & xx's
            </Text>
            <Text className="font-body" fontSize="13px" color="rgba(255,255,255,0.65)" letterSpacing="0.1em" textAlign={{
            base: 'center',
            lg: 'left'
          }} data-id="element-78">
              Vintage • Upcycled • Original Designs
            </Text>
            <HStack spacing={2} mt={2} data-id="element-79">
              <IconButton aria-label="Instagram" icon={<InstagramIcon size={18} data-id="element-81" />} variant="ghost" color="white" minW="44px" h="44px" borderRadius="full" _hover={{
              bg: 'rgba(244,184,193,0.2)',
              color: '#F4B8C1'
            }} data-id="element-80" />
              <IconButton aria-label="TikTok" icon={<TikTokIcon size={18} data-id="element-83" />} variant="ghost" color="white" minW="44px" h="44px" borderRadius="full" _hover={{
              bg: 'rgba(244,184,193,0.2)',
              color: '#F4B8C1'
            }} data-id="element-82" />
              <IconButton aria-label="Facebook" icon={<FacebookIcon size={18} data-id="element-85" />} variant="ghost" color="white" minW="44px" h="44px" borderRadius="full" _hover={{
              bg: 'rgba(244,184,193,0.2)',
              color: '#F4B8C1'
            }} data-id="element-84" />
            </HStack>
          </VStack>

          {/* Column 2: Quick Links */}
          <VStack align={{
          base: 'center',
          lg: 'flex-start'
        }} spacing={3} data-id="element-86">
            <Text className="font-body" fontSize="12px" fontWeight={700} letterSpacing="0.15em" textTransform="uppercase" color="#F4B8C1" mb={1} data-id="element-87">
              Quick Links
            </Text>
            {['Shop', 'Collections', 'About', 'Pop-Ups', 'Contact'].map(link => <Link key={link} href="#" className="font-body" fontSize="14px" color="rgba(255,255,255,0.75)" textDecoration="none" _hover={{
            color: '#F4B8C1',
            textDecoration: 'none'
          }} transition="color 0.2s" data-id="element-88">
                  {link}
                </Link>)}
          </VStack>

          {/* Column 3: Customer Care */}
          <VStack align={{
          base: 'center',
          lg: 'flex-start'
        }} spacing={3} data-id="element-89">
            <Text className="font-body" fontSize="12px" fontWeight={700} letterSpacing="0.15em" textTransform="uppercase" color="#F4B8C1" mb={1} data-id="element-90">
              Customer Care
            </Text>
            {['Shipping & Returns', 'FAQ', 'Size Guide'].map(link => <Link key={link} href="#" className="font-body" fontSize="14px" color="rgba(255,255,255,0.75)" textDecoration="none" _hover={{
            color: '#F4B8C1',
            textDecoration: 'none'
          }} transition="color 0.2s" data-id="element-91">
                {link}
              </Link>)}
          </VStack>

          {/* Column 4: Faith note */}
          <VStack align={{
          base: 'center',
          lg: 'flex-start'
        }} spacing={4} data-id="element-92">
            <Text className="font-body" fontSize="12px" fontWeight={700} letterSpacing="0.15em" textTransform="uppercase" color="#F4B8C1" mb={1} data-id="element-93">
              Our Heart
            </Text>
            <Text className="font-body" fontSize="14px" color="rgba(255,255,255,0.7)" lineHeight={1.7} textAlign={{
            base: 'center',
            lg: 'left'
          }} data-id="element-94">
              Every piece is made with love, purpose, and prayer. We're more
              than a brand — we're a sisterhood.
            </Text>
            <Text className="font-script" fontSize="22px" color="#F4B8C1" data-id="element-95">
              Lots of Love & xx's 💕
            </Text>
          </VStack>
        </SimpleGrid>

        <Divider borderColor="rgba(255,255,255,0.12)" data-id="element-96" />

        {/* Bottom bar */}
        <Flex direction={{
        base: 'column',
        md: 'row'
      }} justify="space-between" align="center" py={6} gap={3} textAlign="center" data-id="element-97">
          <Text className="font-body" fontSize="13px" color="rgba(255,255,255,0.5)" data-id="element-98">
            © 2026 Love & xx's. All rights reserved.
          </Text>
          <Text className="font-body" fontSize="13px" color="rgba(255,255,255,0.5)" fontStyle="italic" data-id="element-99">
            "She is clothed in strength and dignity" — Proverbs 31:25 💕
          </Text>
        </Flex>
      </Box>
    </Box>;
}